/* eslint-disable global-require */
module.exports = ['auctioneers.contact.messagesent.m3', 'artprice.lib.tour.tour4.m63'];
